import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from 'ng2-translate/ng2-translate';
import { ToasterModule } from 'angular2-toaster/angular2-toaster';

import { AccordionModule } from 'ng2-bootstrap/accordion';
import { AlertModule } from 'ng2-bootstrap/alert';
import { ButtonsModule } from 'ng2-bootstrap/buttons';
import { CarouselModule } from 'ng2-bootstrap/carousel';
import { CollapseModule } from 'ng2-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ModalModule } from 'ng2-bootstrap/modal';
import { PaginationModule } from 'ng2-bootstrap/pagination';
import { ProgressbarModule } from 'ng2-bootstrap/progressbar';
import { RatingModule } from 'ng2-bootstrap/rating';
import { TabsModule } from 'ng2-bootstrap/tabs';
import { TimepickerModule } from 'ng2-bootstrap/timepicker';
import { TooltipModule } from 'ng2-bootstrap/tooltip';
import { TypeaheadModule } from 'ng2-bootstrap/typeahead';
import { DatepickerModule } from 'ng2-bootstrap/datepicker';
import {SelectModule} from 'ng2-select';
import { NgxMyDatePickerModule } from 'ngx-mydatepicker';
import { ChartsModule as Ng2ChartsModule } from 'ng2-charts/ng2-charts';

import { FlotDirective } from './directives/flot/flot.directive';
import { SparklineDirective } from './directives/sparkline/sparkline.directive';
import { EasypiechartDirective } from './directives/easypiechart/easypiechart.directive';
import { ColorsService } from './colors/colors.service';
import { CheckallDirective } from './directives/checkall/checkall.directive';
import { VectormapDirective } from './directives/vectormap/vectormap.directive';
import { NowDirective } from './directives/now/now.directive';
import { ScrollableDirective } from './directives/scrollable/scrollable.directive';
import { JqcloudDirective } from './directives/jqcloud/jqcloud.directive';
import {ImportWidgetComponent} from "../routes/common/import-widget/import-widget.component";
import { DatepickerService } from './services/datepicker.service';
import {IssuesGraphWidgetComponent} from "../routes/common/issues-graph-widget/issues-graph-widget.component";
import { TimeInHoursPipe } from './pipes/time-in-hours.pipe';
import { CustomValidatorsDirective } from './validators/custom-validators.directive';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { TimeInUnitsPipe } from './pipes/time-in-units.pipe';

import { AgmOverrideModule } from './maps/agm-override.module'

// https://angular.io/styleguide#!#04-10
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        AccordionModule.forRoot(),
        AlertModule.forRoot(),
        ButtonsModule.forRoot(),
        CarouselModule.forRoot(),
        CollapseModule.forRoot(),
        DatepickerModule.forRoot(),
        BsDropdownModule.forRoot(),
        ModalModule.forRoot(),
        PaginationModule.forRoot(),
        ProgressbarModule.forRoot(),
        RatingModule.forRoot(),
        TabsModule.forRoot(),
        TimepickerModule.forRoot(),
        TooltipModule.forRoot(),
        TypeaheadModule.forRoot(),
        AgmOverrideModule.forRoot({
            apiKey: 'AIzaSyAvtlPnSYNZLsNuGfGMy0cq2O-EnC10QMw'
        }),
        ToasterModule,
        SelectModule,
        NgxMyDatePickerModule,
        Ng2ChartsModule
    ],
    providers: [
        ColorsService,
        DatepickerService
    ],
    declarations: [
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        ImportWidgetComponent,
        IssuesGraphWidgetComponent,
        TimeInHoursPipe,
        CustomValidatorsDirective,
        TimeInUnitsPipe,
        SafeHtmlPipe
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        RouterModule,
        AccordionModule,
        AlertModule,
        ButtonsModule,
        CarouselModule,
        CollapseModule,
        DatepickerModule,
        BsDropdownModule,
        ModalModule,
        PaginationModule,
        ProgressbarModule,
        RatingModule,
        TabsModule,
        TimepickerModule,
        TooltipModule,
        TypeaheadModule,
        ToasterModule,
        FlotDirective,
        SparklineDirective,
        EasypiechartDirective,
        CheckallDirective,
        VectormapDirective,
        NowDirective,
        ScrollableDirective,
        JqcloudDirective,
        SelectModule,
        NgxMyDatePickerModule,
        ImportWidgetComponent,
        IssuesGraphWidgetComponent,
        TimeInHoursPipe,
        TimeInUnitsPipe,
        SafeHtmlPipe
    ]
})

// https://github.com/ocombe/ng2-translate/issues/209
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts